import axios from 'axios';

// const Conect = axios.create({ baseURL: 'http://192.168.0.5:9865' });
// const Conect = axios.create({ baseURL: 'http://server.sakamottosann.com.br:9865' });
const Conect = axios.create({ baseURL: 'https://sakamottosann.com.br/api4' });

export default Conect;